import { hotPosts } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function HotPosts() {
  return (
    <section id="hot">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="本周热议"
          title="社区正在热议，别错过后续"
          desc="由真实讨论热度梳理出的精选话题，配图克制、内容为王。点开标题即可跟进完整长帖与最新进展。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {hotPosts.map((p) => (
            <article
              key={p.title}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300/70"
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  title={`${p.title} · 吃瓜地址热门热议`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-primary-700">
                  <i className="ri-fire-fill text-accent-600"></i>
                  热议
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="cursor-pointer text-[15px] font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                  {p.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{p.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3.5 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-heart-3-line text-primary-500"></i>
                    {p.likes}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {p.views}
                  </span>
                  <span className="inline-flex items-center gap-1 font-medium text-foreground-800">
                    看全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}